import { render, staticRenderFns } from "./AnexosSwisstex.vue?vue&type=template&id=5aab3d62&scoped=true&"
import script from "./AnexosSwisstex.vue?vue&type=script&lang=js&"
export * from "./AnexosSwisstex.vue?vue&type=script&lang=js&"
import style0 from "./AnexosSwisstex.vue?vue&type=style&index=0&id=5aab3d62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab3d62",
  null
  
)

export default component.exports